export default __webpack_public_path__ + "title-section.png";